import {useTranslation} from "react-i18next";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import React from "react";
import {FormHelperText} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {
    CustomStyleFormHelperText,
    CustomStyleSelect,
    CustomStyleSelectMenuPaper,
    CustomStyleSelectRequired
} from "./Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Select
 * @param String id: Identifier for the select (required)
 * @param String name: Name for the select (optional)
 * @param Array<JSX.Element> children: List of JSX.Element (required)
 * @param Object inputProps: Defines attributes to apply to the native select (optional)
 * @param String defaultValue: Define a default value for select (optional)
 * @param String value: Selected option (required)
 * @param String key: Defines the key attribute for the select (optional)
 * @param Boolean disabled: Enable/disable interaction with the select (optional)
 * @param String trans: Text for the label (required)
 * @param Boolean emptyFields: Indicates if the field is empty (optional)
 * @param Boolean required: Indicates if the select is required (optional)
 * @param Boolean showNoSelectionOption: If showNoSelectionOption===false, no show default option (optional)
 * @param String helperText: Text for the legend, displayed under the input field (optional)
 * @param Event onChange: onChange trigger for the select (optional)
 * @param Boolean isValid: Show legend and input with error when isValid = false (optional)
 * @param String isValidText: Legend for input with error (optional)
 * @param String placeholder: Placeholder text shown as the first option (optional)
 * @returns {JSX.Element}
 */
const SELECT_MENU_PROPS = {
    PaperProps: {
        className: "overflow-y-auto maxh-40vh",
        sx: CustomStyleSelectMenuPaper
    }
};

export const CustomSelectAndChildren = ({id, name, children, inputProps, defaultValue, value, key, disabled, trans,
                                             emptyFields, required, showNoSelectionOption=true, helperText='', onChange,
                                            isValid=true, isValidText='',  placeholder, marginBottom=true}) =>{
    const { t } = useTranslation();

    let attrs = {
        size:"small",
        name:name,
        value: value ?? '',
        required:required,
        disabled:disabled,
        onChange:onChange,
        defaultValue:defaultValue,
        key:key,
        inputProps:{...inputProps, id:id},
        MenuProps: SELECT_MENU_PROPS
    };

    if(typeof value === "undefined"){
        delete attrs.value;
    }

    if(typeof defaultValue === "undefined"){
        delete attrs.defaultValue;
    }

    if(typeof key === "undefined"){
        delete attrs.key;
    }

    return <>
        <FormControl fullWidth sx={((emptyFields && (typeof value === "undefined" || value === '' || value === null)) || (!isValid && value !== '')) ? CustomStyleSelectRequired:CustomStyleSelect(marginBottom)}
                     error={(emptyFields && (typeof value === "undefined" || value === '' || value === null)) || (!isValid && value !== '')}>
            <InputLabel disabled={disabled}>
                {t(trans)} {required === true ? ' *':''}
            </InputLabel>
            <Select {...attrs}>
                {placeholder && (
                  <MenuItem value='' disabled>
                    {t(placeholder)}
                  </MenuItem>
                )}
                {showNoSelectionOption && <MenuItem id='mi-csac-no-selection' value={null}>{t("no_selection").toUpperCase()}</MenuItem>}
                {children}
            </Select>

            {(emptyFields && (typeof value === "undefined" || value === '' || value === null)) &&
                <FormHelperText
                    id="outlined-weight-helper-text"
                    error={true}
                    sx={CustomStyleFormHelperText(false, marginBottom)}
                >
                    {t('requiredField')}
                </FormHelperText>
            }

            {(!isValid && value !== '') &&
                <FormHelperText
                    error={true}
                    sx={CustomStyleFormHelperText(false, marginBottom)}
                >
                    {t(isValidText)}
                </FormHelperText>
            }

            {helperText && !emptyFields && !isValid &&
                <FormHelperText
                    className={`css-k4qjio-MuiFormHelperText-root`}
                    sx={CustomStyleFormHelperText(false, false)}
                >
                    {helperText}
                </FormHelperText>
            }
        </FormControl>
    </>
}
